<template>
  <div>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @row-del="rowDel"
      v-model="form"
      :permission="permissionList"
      @row-update="rowUpdate"
      @row-save="rowSave"
      :before-open="beforeOpen"
      @upload-after="uploadAfter"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <template slot-scope="{ row, index }" slot="menu">
        <el-button
          v-if="permissionList.viewBtn"
          type="text"
          size="small"
          @click="handleRowView(row, index)"
        >查看</el-button>
        <el-button
          v-if="permissionList.viewBtn || permissionList.editBtn"
          type="text"
          size="small"
          @click="openReadDialog(row)"
        >阅读记录</el-button>
        <el-button
          v-if="permissionList.editBtn"
          type="text"
          size="small"
          @click="$refs.crud.rowEdit(row, index)"
        >编辑</el-button>
        <el-button
          v-if="permissionList.editBtn && canPublish(row)"
          type="text"
          size="small"
          @click="handlePublish(row)"
        >发布</el-button>
        <el-button
          v-if="permissionList.editBtn && isPublished(row)"
          type="text"
          size="small"
          @click="handleOffline(row)"
        >下线</el-button>
        <el-button
          v-if="permissionList.delBtn"
          type="text"
          size="small"
          @click="$refs.crud.rowDel(row, index)"
        >删除</el-button>
      </template>
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          v-if="permissionList.delBtn"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
      <template slot-scope="{ row }" slot="clientId">
        <el-tag size="small">{{ row.clientName || row.clientId || '—' }}</el-tag>
      </template>
      <template slot-scope="{ row }" slot="forceRead">
        <el-tag size="small" :type="row.forceRead === 1 ? 'danger' : 'info'">
          {{ row.forceRead === 1 ? '强制' : '普通' }}
        </el-tag>
      </template>
      <template slot-scope="{ row }" slot="status">
        <el-tag size="small" :type="statusTagType(row.status)">
          {{ statusLabel(row.status) }}
        </el-tag>
      </template>
      <template slot-scope="{ row }" slot="fileSlot">
        <el-link
          v-if="row.fileUrl"
          type="primary"
          :href="row.fileUrl"
          target="_blank"
          :underline="false"
        >{{ row.fileName || '附件' }}</el-link>
        <span v-else style="color:#c0c4cc;">—</span>
      </template>
    </avue-crud>

    <el-dialog
      :title="readDialogTitle"
      :visible.sync="readDialogVisible"
      width="920px"
      append-to-body
      @closed="onReadDialogClosed"
    >
      <div style="margin-bottom: 12px">
        <el-input
          v-model="readUserNameQuery"
          placeholder="用户名（模糊）"
          clearable
          style="width: 220px; margin-right: 8px"
          @keyup.enter.native="loadReadPage(1)"
        />
        <el-button type="primary" size="small" @click="loadReadPage(1)">查询</el-button>
      </div>
      <el-table v-loading="readLoading" :data="readTableData" border size="small">
        <el-table-column type="index" width="50" label="#" />
        <el-table-column prop="clientName" label="接收端" min-width="100" />
        <el-table-column prop="userId" label="用户ID" width="100" />
        <el-table-column prop="userName" label="用户名" min-width="120" />
        <el-table-column label="签名" min-width="120">
          <template slot-scope="{ row }">
            <el-link
              v-if="row.signatureUrl"
              :href="row.signatureUrl"
              target="_blank"
              type="primary"
              :underline="false"
            >查看</el-link>
            <span v-else style="color: #c0c4cc">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="阅读时间" width="170" />
      </el-table>
      <el-pagination
        style="margin-top: 12px; text-align: right"
        :current-page="readPage.currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="readPage.pageSize"
        :total="readPage.total"
        layout="total, sizes, prev, pager, next"
        @size-change="readSizeChange"
        @current-change="readCurrentChange"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getList, remove, update, add, getNotice } from "@/api/desk/notice";
import { getNoticeReadPage } from "@/api/desk/noticeUser";
import { mapGetters } from "vuex";
import { removePercent } from '@/util/util'

const uploadAction = '/api/blade-resource/oss/endpoint/put-file';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: "auto",
        calcHeight: 30,
        dialogWidth: 950,
        menuWidth: 400,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        selection: true,
        excelBtn: true,
        dialogClickModal: false,
        column: [
          {
            label: "通知标题",
            prop: "title",
            span: 24,
            row: true,
            search: true,
            minWidth: 200,
            overHidden: true,
            rules: [
              {
                required: true,
                message: "请输入通知标题",
                trigger: "blur",
              },
            ],
          },
          {
            label: "接收端",
            prop: "clientId",
            type: "select",
            slot: true,
            search: true,
            dicData: [
              { label: "所有人", value: "ALL" },
              { label: "企业端", value: "client_enterprise" },
              { label: "司机端", value: "client_driver" },
              { label: "客户", value: "client_custom" },
            ],
            rules: [
              {
                required: true,
                message: "请选择接收端",
                trigger: "change",
              },
            ],
            minWidth: 120,
          },
          {
            label: "发布时间范围",
            prop: "releaseTimeRange",
            type: "datetimerange",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            searchRange: true,
            hide: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
          },
          {
            label: "发布时间",
            prop: "releaseTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            span: 12,
            minWidth: 170,
          },
          {
            label: "状态",
            prop: "status",
            type: "select",
            slot: true,
            search: true,
            valueDefault: 0,
            dicData: [
              { label: "草稿", value: 0 },
              { label: "已发布", value: 1 },
              { label: "已下线", value: 2 },
            ],
            rules: [
              {
                required: true,
                message: "请选择状态",
                trigger: "change",
              },
            ],
            minWidth: 100,
          },
          {
            label: "强制阅读",
            prop: "forceRead",
            type: "switch",
            slot: true,
            search: true,
            valueDefault: 0,
            dicData: [
              { label: "普通", value: 0 },
              { label: "强制", value: 1 },
            ],
            minWidth: 100,
            span: 12,
          },
          {
            label: "通知内容",
            prop: "content",
            type: "textarea",
            minRows: 6,
            maxRows: 12,
            maxlength: 2000,
            showWordLimit: true,
            span: 24,
            hide: true,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: "请输入通知内容",
                trigger: "blur",
              },
            ],
          },
          {
            label: "附件上传",
            prop: "fileUrl",
            type: "upload",
            limit: 1,
            drag: true,
            action: uploadAction,
            propsHttp: {
              res: "data",
              url: "link",
            },
            tip: "单附件：上传成功后写入 fileUrl，文件名尽量在下方「文件名称」中确认",
            hide: true,
            span: 24,
          },
          {
            label: "文件名称",
            prop: "fileName",
            span: 24,
            maxlength: 200,
            showWordLimit: true,
            hide: true,
            addDisplay: true,
            editDisplay: true,
            viewDisplay: true,
            placeholder: "可手工填写或由上传自动带出",
          },
          {
            label: "附件",
            prop: "fileSlot",
            slot: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            hide: false,
            minWidth: 140,
          },
        ],
      },
      data: [],
      readDialogVisible: false,
      readDialogTitle: "",
      readLoading: false,
      readNoticeId: null,
      readUserNameQuery: "",
      readTableData: [],
      readPage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      const p = this.permission || {};
      const on = (k) => p[k] === true;
      const keys = ["notice_add", "notice_edit", "notice_delete", "notice_view"];
      const hasAny = keys.some((k) => on(k));
      // 未下发任何 notice_* 按钮权限（如仅静态路由打开页）时默认展示 CRUD，避免无新增按钮；有任意一项则按细粒度控制
      if (!hasAny) {
        return {
          addBtn: true,
          viewBtn: true,
          editBtn: true,
          delBtn: true,
        };
      }
      return {
        addBtn: on("notice_add"),
        viewBtn: on("notice_view"),
        delBtn: on("notice_delete"),
        editBtn: on("notice_edit"),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  methods: {
    uploadAfter(res, done, loading, column) {
      if (column && column.prop === "fileUrl" && res && res.data) {
        const d = res.data.data != null ? res.data.data : res.data;
        const name = (d && (d.originalName || d.attachName || d.name)) || "";
        if (name) {
          this.form.fileName = name;
        }
      }
      done();
    },
    statusLabel(v) {
      const m = { 0: "草稿", 1: "已发布", 2: "已下线" };
      return m[v] != null ? m[v] : "—";
    },
    statusTagType(v) {
      if (v === 1) return "success";
      if (v === 2) return "info";
      return "warning";
    },
    /** 草稿、已下线可发布 */
    canPublish(row) {
      const s = row && row.status;
      return s === 0 || s === 2 || s === "0" || s === "2";
    },
    isPublished(row) {
      const s = row && row.status;
      return s === 1 || s === "1";
    },
    handleRowView(row, index) {
      this.$refs.crud.rowView(row, index);
    },
    openReadDialog(row) {
      if (!row || !row.id) {
        return;
      }
      this.readNoticeId = row.id;
      this.readDialogTitle =
        "阅读记录 — " + (row.title ? row.title : "ID:" + row.id);
      this.readUserNameQuery = "";
      this.readPage = { currentPage: 1, pageSize: 10, total: 0 };
      this.readDialogVisible = true;
      this.$nextTick(() => this.loadReadPage(1));
    },
    loadReadPage(toFirstPage) {
      if (!this.readNoticeId) {
        return;
      }
      if (toFirstPage === 1) {
        this.readPage.currentPage = 1;
      }
      this.readLoading = true;
      const params = { noticeId: this.readNoticeId };
      if (this.readUserNameQuery && String(this.readUserNameQuery).trim()) {
        params.userName = String(this.readUserNameQuery).trim();
      }
      getNoticeReadPage(
        this.readPage.currentPage,
        this.readPage.pageSize,
        params
      )
        .then((res) => {
          const d = res.data.data;
          this.readTableData = (d && d.records) || [];
          this.readPage.total = (d && d.total) || 0;
        })
        .finally(() => {
          this.readLoading = false;
        });
    },
    readSizeChange(size) {
      this.readPage.pageSize = size;
      this.readPage.currentPage = 1;
      this.loadReadPage();
    },
    readCurrentChange(cur) {
      this.readPage.currentPage = cur;
      this.loadReadPage();
    },
    onReadDialogClosed() {
      this.readTableData = [];
      this.readNoticeId = null;
      this.readUserNameQuery = "";
    },
    handlePublish(row) {
      this.$confirm("确认发布该公告？发布后状态为「已发布」。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => update(Object.assign({}, row, { status: 1 })))
        .then(() => {
          this.$message.success("已发布");
          this.onLoad(this.page);
        })
        .catch(() => {});
    },
    handleOffline(row) {
      this.$confirm("确认下线该公告？下线后状态为「已下线」。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => update(Object.assign({}, row, { status: 2 })))
        .then(() => {
          this.$message.success("已下线");
          this.onLoad(this.page);
        })
        .catch(() => {});
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm_danger("删除")
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm_danger("删除")
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getNotice(this.form.id).then((res) => {
          this.form = res.data.data;
        });
      }
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      const { releaseTimeRange } = this.query;
      let values = {
        ...params,
        ...this.query,
      };
      if (releaseTimeRange) {
        values = {
          ...values,
          releaseTime_datege: releaseTimeRange[0],
          releaseTime_datelt: releaseTimeRange[1],
        };
        values.releaseTimeRange = null;
      }
      this.loading = true;
      values = removePercent(this.deepClone(values))
      getList(page.currentPage, page.pageSize, values).then((res) => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style></style>
